/*eslint-disable*/
export const messages = {
  "Cancel": "Отмена",
  "Change theme": "Изменить тему",
  "Clear chat": "Очистить чат",
  "Clear chat history": "Очистить историю чата",
  "Connecting...": "Соединение...",
  "Continue": "Продолжить",
  "Decrease font size": "Уменьшить размер шрифта",
  "Disclaimer": "Отказ от ответственности",
  "Enter your message...": "Введите ваше сообщение...",
  "Type your message...": "Введите ваше сообщение...",
  "Error": "Ошибка",
  "Font size": "Размер шрифта",
  "Increase font size": "Увеличить размер шрифта",
  "Language": "Язык",
  "MJ Lab": "Лаборатория MJ",
  "Reset font size": "Сбросить размер шрифта",
  "Respond time: {time}s": "Время ответа: {time} с",
  "Response time:": "Время ответа:",
  "Send": "Отправить",
  "Settings": "Настройки",
  "Support the project": "Поддержать проект",
  "System": "Система",
  "Theme": "Тема",
  "Thinking...": "Обдумывание...",
  "Toggle theme": "Переключить тему",
  "Welcome to {{name}} by MJ": "Добро пожаловать в {{name}} от MJ",
  "You asked:": "Вы спросили:",
  
  // Headers
  "Labor Law Expert": "Эксперт по трудовому праву",
  "by MJ": "от MJ",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Здравствуйте, я {{name}}, ИИ-ассистент, созданный MJ.",
  "I am expert in labor laws and regulations for Saudi Arabia.": "Я эксперт по трудовому законодательству и нормативным актам Саудовской Аравии.",
  "Ask me a question, and I will gladly answer you.": "Задайте мне вопрос, и я с радостью вам отвечу.",
  "Do not share confidential data.": "Не делитесь конфиденциальными данными.",
  "I am powered using": "Я работаю на основе",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi labor laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Отказ от ответственности:** {{name}} - это экспериментальный ИИ-ассистент, созданный для ответов на основе данных из трудового законодательства и нормативных актов Саудовской Аравии, избегая предположений и неточностей. Я не несу ответственности за его поведение или правильность его ответов.",
  
  // Frameworks
  "Automatic detection": "Автоматическое определение",
  "Labor Law": "Трудовое законодательство",
  "Saudization": "Саудизация",
  "Contracts": "Трудовые договоры",
  "Termination": "Прекращение трудовых отношений",
  "Wages & Benefits": "Заработная плата и льготы",
  "Leave Policies": "Политики отпусков",
  "Workplace Safety": "Безопасность на рабочем месте",
  
  // Models
  "Claude by Anthropic": "Claude от Anthropic",
  "DeepSeek by Groq": "DeepSeek от Groq",
  "MJ Lab Mode": "Режим лаборатории MJ",
  
  // Character count
  "{{remainingChars}} character left": "Остался {{remainingChars}} символ",
  "{{remainingChars}} characters left": "Осталось {{remainingChars}} символов",
  
  // Error messages
  "An error occurred": "Произошла ошибка",
  "Failed to change language": "Не удалось изменить язык",
  "Please try again": "Пожалуйста, попробуйте снова",
  "Connection lost": "Соединение потеряно",
  "Reconnecting...": "Переподключение...",
  "Nothing to clear": "Нечего очищать",
  "All messages cleared": "Все сообщения удалены",
  "All data cleared": "Все данные удалены",
  "Storage limit reached": "Достигнут предел хранилища",
  "Some older messages were removed to save space.": "Некоторые старые сообщения были удалены для экономии места.",
  
  // Additional keys
  "Font Size": "Размер шрифта",
  "Language changed to {locale}": "Язык изменен на {locale}",
  "Select language": "Выберите язык",
  "Support": "Поддержка",
  
  // Brand names (do not translate)
  "Leen": "Leen",
  
  // Message actions
  "Message copied to clipboard": "Сообщение скопировано в буфер обмена",
  "Read": "Прочитать",
  "Summarize": "Обобщить",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Предложения сообщений",
  "Select a question to quickly start a conversation about Saudi labor laws.": "Выберите вопрос, чтобы быстро начать разговор о трудовом законодательстве Саудовской Аравии.",
  "What are the key employee rights under Saudi labor law? Can you provide a simple overview?": "Каковы основные права работников согласно трудовому законодательству Саудовской Аравии? Можете предоставить краткий обзор?",
  "What are the employer's obligations regarding work hours, overtime, and leave in Saudi Arabia?": "Каковы обязанности работодателя в отношении рабочего времени, сверхурочной работы и отпусков в Саудовской Аравии?",
  "How does Saudi labor law handle termination of employment and end-of-service benefits?": "Как трудовое законодательство Саудовской Аравии регулирует увольнение и выплаты при окончании трудовых отношений?",
  
  // Audio Player Dialog
  "AI Summary": "Сводка ИИ",
  "Listen to the summarized response using our AI Service.": "Прослушайте краткий ответ с помощью нашего ИИ-сервиса.",
  "Generating summary...": "Создание сводки...",
  "Preparing audio...": "Подготовка аудио...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Не удалось обработать текст. Пожалуйста, попробуйте снова.",
  "Failed to auto-play audio. Click play to try again.": "Не удалось автоматически воспроизвести аудио. Нажмите кнопку воспроизведения, чтобы попробовать снова.",
  "Failed to load audio. Please try again.": "Не удалось загрузить аудио. Пожалуйста, попробуйте снова.",
  "Audio playback was aborted.": "Воспроизведение аудио было прервано.",
  "Network error occurred while loading audio.": "Произошла сетевая ошибка при загрузке аудио.",
  "Audio decoding failed.": "Не удалось декодировать аудио.",
  "Audio format not supported.": "Формат аудио не поддерживается.",
  "Failed to setup audio playback": "Не удалось настроить воспроизведение аудио",
  "Failed to generate speech": "Не удалось сгенерировать речь",
  "Failed to generate audio. Please try again.": "Не удалось сгенерировать аудио. Пожалуйста, попробуйте снова.",
  "Failed to play audio. Please try again.": "Не удалось воспроизвести аудио. Пожалуйста, попробуйте снова.",
  
  // Update Notifications
  "update.updateAvailable": "Доступно обновление",
  "update.newVersionAvailable": "Доступна новая версия {{version}}",
  "update.refreshToApply": "Обновите страницу, чтобы применить последние функции и улучшения",
  "update.later": "Позже",
  "update.updateNow": "Обновить сейчас",
  
  // CSAT Feedback
  "We Value Your Feedback": "Мы ценим ваше мнение",
  "Give Feedback": "Оставить отзыв",
  "How would you rate your experience?": "Как бы вы оценили свой опыт?",
  "Very Dissatisfied": "Очень недоволен",
  "Dissatisfied": "Недоволен",
  "Neutral": "Нейтрально",
  "Satisfied": "Доволен",
  "Very Satisfied": "Очень доволен",
  "Select a rating": "Выберите оценку",
  "Comments or Bug Report": "Комментарии или отчет об ошибке",
  "Please share your thoughts or report any issues...": "Пожалуйста, поделитесь своими мыслями или сообщите о проблемах...",
  "Contact Number": "Контактный номер",
  "Feedback Type": "Тип отзыва",
  "Select a feedback type": "Выберите тип отзыва",
  "Loading...": "Загрузка...",
  "No feedback types available": "Нет доступных типов отзыва", 
  "(Optional)": "(Необязательно)",
  "Feedback Submitted": "Отзыв отправлен",
  "Thank you for your feedback!": "Спасибо за ваш отзыв!",
  "Rating Required": "Требуется оценка",
  "Please select a rating before submitting.": "Пожалуйста, выберите оценку перед отправкой.",
  "Submit Feedback": "Отправить отзыв",
  "Submitting...": "Отправка...",
  "General": "Общий",
  "Bug": "Ошибка",
  "Idea": "Идея",
  
  // Feedback Dashboard
  "Feedback Dashboard": "Панель отзывов",
  "Total Feedbacks": "Всего отзывов",
  "All-time submissions": "Все отправленные отзывы",
  "Average Rating": "Средняя оценка",
  "Out of 5 stars": "Из 5 звезд",
  "Feedback with Comments": "Отзывы с комментариями",
  "Detailed feedback": "Подробные отзывы",
  "Rating Distribution": "Распределение оценок",
  "Breakdown of user satisfaction": "Анализ удовлетворенности пользователей",
  "Rating Percentage": "Процент оценок",
  "Proportion of each rating": "Доля каждой оценки",
  "Responses": "Ответы",
  "All Feedback": "Все отзывы",
  "Detailed view of user submissions": "Подробный просмотр пользовательских отзывов",
  "ID": "ID",
  "Rating": "Оценка",
  "Comment": "Комментарий",
  "Contact": "Контакт",
  "Date": "Дата",
  "Page": "Страница",
  "No feedback data available": "Нет доступных данных отзывов",
  "No comment": "Без комментария",
  "Not provided": "Не указано",
  "Not available": "Недоступно",
  
  // Authentication
  "Login": "Вход",
  "Register": "Регистрация",
  "Username": "Имя пользователя",
  "Password": "Пароль",
  "Confirm Password": "Подтвердите пароль",
  "Email": "Электронная почта",
  "Full Name": "Полное имя",
  "Don't have an account?": "Нет учетной записи?",
  "Already have an account?": "Уже есть учетная запись?",
  "Login to continue": "Войдите, чтобы продолжить",
  "Create an account": "Создать учетную запись",
  "Passwords must match": "Пароли должны совпадать",
  "Invalid email": "Неверный адрес электронной почты",
  "Required": "Обязательно",
  "Unauthorized": "Неавторизовано",
  "You don't have permission to access this page.": "У вас нет разрешения на доступ к этой странице."
};